import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'hooks/apollo';
import { REMOVE_DOCUMENT_TYPE_PROPERTY } from '../mutations';
import { TableRow, TableCell } from '@mui/material';
import TextTableCell from 'components/common/table/TextTableCell';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import { IconButton } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE } from 'constants/rightsCodes';

const DocumentTypePropertyListItem = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const confirm = useConfirmDialog();

  const [pending, setPending] = useState(false);
  const canWrite = usePermission(ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE);

  const [removeDocumentTypeProperty] = useMutation(REMOVE_DOCUMENT_TYPE_PROPERTY);

  const handleEdit = () => {
    historyContext.push(`/documentTypes/${data.documentTypeId}/documentTypeProperties/${data.propertyId}`);
  };

  const handleDelete = useCallback(() => {
    confirm(
      () => {
        setPending(true);
        removeDocumentTypeProperty({
          variables: {
            input: { documentTypeId: data.documentTypeId, propertyId: data.propertyId }
          }
        });
      },
      {
        content: t('DocumentTypes.DocumentTypeProperty.DeleteDocumentTypeProperty')
      }
    );
  }, [confirm, removeDocumentTypeProperty, t, data]);

  return (
    <TableRow>
      <TextTableCell content={data.propertyCode} />
      <TextTableCell content={data.propertyName} />
      <TextTableCell content={data.propertyTypeName} />
      <TextTableCell content={data.defaultValue} />
      <TextTableCell content={data.propertyCode} />
      <CheckboxTableCell checked={data.mandatory} />
      <CheckboxTableCell checked={data.implicit} />
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            type={canWrite ? 'edit' : 'view'}
            variant='text'
            color='primary'
            size='small'
            tooltip={canWrite ? t('Edit') : t('View')}
            onClick={handleEdit}
            disabled={pending}
          />
          {canWrite && (
            <IconButton
              type='delete'
              variant='text'
              color='primary'
              size='small'
              tooltip={t('Delete')}
              onClick={handleDelete}
              disabled={pending}
            />
          )}
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

DocumentTypePropertyListItem.propTypes = {
  data: PropTypes.object
};
export default DocumentTypePropertyListItem;
